import { Icon, Modal, ButtonBase, RadioGroup, FormControlLabel, Radio, FormLabel, TextField, Button, CircularProgress } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { rateProducer } from 'store/Orbita/Showcase/actions';

import styles from '../../styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  classes?: any;
  open: boolean;
  onClose: any;
  producerId: any;
}

interface IStates {
  isSubmitting: boolean;
  rating: {
    training_support: string;
    material_product: string;
    disponibility: string;
    awards: string;
    respect: string;
    comment: string;
  };
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

class ModalEvaluation extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isSubmitting: false,
      rating: {
        training_support: '1',
        material_product: '1',
        disponibility: '1',
        awards: '1',
        respect: '1',
        comment: '',
      },
    };
  }

  handleChange = (name: string, value: any) => {
    const { rating } = this.state;
    rating[name] = value;
    this.setState({ rating });
  };

  handleSubmit = async () => {
    const { rating } = this.state;
    const { producerId, onClose } = this.props;
    this.setState({ isSubmitting: true });
    await this.props.dispatch(rateProducer(producerId, rating));
    this.setState({ isSubmitting: false });
    toast.success('Avaliação feita com sucesso!');
    onClose();
  };

  render() {
    const { classes, onClose } = this.props;
    const { rating, isSubmitting } = this.state;
    return (
      <Modal open={this.props.open}>
        <div style={getModalStyle()} className={classes.modalEvaluation}>
          <h2 className={`${classes.cardTitle} modalHead`}>Avaliar Produtor</h2>
          <div className={classes.modalClose}>
            <ButtonBase onClick={onClose}>
              <Icon color='primary'>close</Icon>
            </ButtonBase>
          </div>
          <div className={classes.modalContent}>
            <div className={classes.formItem}>
              <FormLabel>Treinamento e Apoio</FormLabel>
              <RadioGroup
                aria-label='Treinamento e Apoio'
                name='producerpool1'
                className={classes.group}
                value={rating.training_support}
                onChange={(e: any) => this.handleChange('training_support', e.target.value)}
                row
              >
                <FormControlLabel value={'1'} control={<Radio />} label='1' />
                <FormControlLabel value={'2'} control={<Radio />} label='2' />
                <FormControlLabel value={'3'} control={<Radio />} label='3' />
                <FormControlLabel value={'4'} control={<Radio />} label='4' />
                <FormControlLabel value={'5'} control={<Radio />} label='5' />
              </RadioGroup>
            </div>
            <div className={classes.formItem}>
              <FormLabel>Material/Informações sobre o Produto</FormLabel>
              <RadioGroup
                aria-label='Gender'
                name='producerpool2'
                className={classes.group}
                value={rating.material_product}
                onChange={(e: any) => this.handleChange('material_product', e.target.value)}
                row
              >
                <FormControlLabel value={'1'} control={<Radio />} label='1' />
                <FormControlLabel value={'2'} control={<Radio />} label='2' />
                <FormControlLabel value={'3'} control={<Radio />} label='3' />
                <FormControlLabel value={'4'} control={<Radio />} label='4' />
                <FormControlLabel value={'5'} control={<Radio />} label='5' />
              </RadioGroup>
            </div>
            <div className={classes.formItem}>
              <FormLabel>Disponibilidade e Suporte ao Afiliado</FormLabel>
              <RadioGroup
                aria-label='Gender'
                name='producerpool3'
                className={classes.group}
                value={rating.disponibility}
                onChange={(e: any) => this.handleChange('disponibility', e.target.value)}
                row
              >
                <FormControlLabel value={'1'} control={<Radio />} label='1' />
                <FormControlLabel value={'2'} control={<Radio />} label='2' />
                <FormControlLabel value={'3'} control={<Radio />} label='3' />
                <FormControlLabel value={'4'} control={<Radio />} label='4' />
                <FormControlLabel value={'5'} control={<Radio />} label='5' />
              </RadioGroup>
            </div>
            <div className={classes.formItem}>
              <FormLabel>Premiações e Incentivos</FormLabel>
              <RadioGroup
                aria-label='Gender'
                name='producerpool4'
                className={classes.group}
                value={rating.awards}
                onChange={(e: any) => this.handleChange('awards', e.target.value)}
                row
              >
                <FormControlLabel value={'1'} control={<Radio />} label='1' />
                <FormControlLabel value={'2'} control={<Radio />} label='2' />
                <FormControlLabel value={'3'} control={<Radio />} label='3' />
                <FormControlLabel value={'4'} control={<Radio />} label='4' />
                <FormControlLabel value={'5'} control={<Radio />} label='5' />
              </RadioGroup>
            </div>
            <div className={classes.formItem}>
              <FormLabel>Ética e Respeito</FormLabel>
              <RadioGroup
                aria-label='Gender'
                name='producerpool5'
                className={classes.group}
                value={rating.respect}
                onChange={(e: any) => this.handleChange('respect', e.target.value)}
                row
              >
                <FormControlLabel value={'1'} control={<Radio />} label='1' />
                <FormControlLabel value={'2'} control={<Radio />} label='2' />
                <FormControlLabel value={'3'} control={<Radio />} label='3' />
                <FormControlLabel value={'4'} control={<Radio />} label='4' />
                <FormControlLabel value={'5'} control={<Radio />} label='5' />
              </RadioGroup>
            </div>
            <div className='m16' />
            <div className={classes.formItem}>
              <TextField
                multiline
                label={'Adicione um comentário sobre esse produtor'}
                fullWidth
                onChange={(e: any) => this.handleChange('comment', e.target.value)}
                InputProps={{
                  disableUnderline: true,
                  rows: 3,
                }}
              />
            </div>
            <div className='m16' />
            <div className={classes.buttonGroup}>
              <Button variant='text' color='default' onClick={onClose} style={{ marginRight: 8 }}>
                Cancelar
              </Button>
              <Button variant='contained' color='primary' disabled={rating.comment.length === 0 || isSubmitting} onClick={this.handleSubmit}>
                Enviar {isSubmitting && <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect()(styles(ModalEvaluation));
